import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { cancelLocationsOfCards } from '../api/simActionsApi';

export const useCancelLocationMutation = (
  options?: Omit<UseMutationOptions<void, Error, { iccids: string[] }, unknown>, 'mutationFn'>,
) => {
  return useMutation({
    ...options,
    mutationFn: (props) => {
      return cancelLocationsOfCards(props);
    },
  });
};
